import React from "react"
import { Box } from "@mui/material"
import { TableFooter } from "mui-datatables"
import ReportIconsLegend from "../IconsLegend"


// The table's own footer (pagination untouched) with the icon legend beside it, under the icons it explains
export default function ReportTableFooter(props) {
	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, '& .MuiTableCell-root': { borderBottom: 'none' } }}>
		<ReportIconsLegend variant="plain" sx={{ pl: 1, flexShrink: 1 }}/>
		<Box sx={{ flex: 1, minWidth: 0 }}>
			<TableFooter {...props}/>
		</Box>
	</Box>
}
